export const DEFAULT_PROMOTION_LABEL_HEX_COLOR = '#000000';

const HEX_COLOR_REGEX = /^#(?:[0-9A-F]{3}|[0-9A-F]{6})$/i;

export const normalizePromotionLabelHexColor = value => {
  const rawValue = String(value || '').trim();
  if (!rawValue) return DEFAULT_PROMOTION_LABEL_HEX_COLOR;

  const prefixedValue = rawValue.startsWith('#') ? rawValue : `#${rawValue}`;
  if (!HEX_COLOR_REGEX.test(prefixedValue)) {
    return null;
  }

  if (prefixedValue.length === 4) {
    return `#${prefixedValue
      .slice(1)
      .split('')
      .map(char => `${char}${char}`)
      .join('')
      .toUpperCase()}`;
  }

  return prefixedValue.toUpperCase();
};

export const getPromotionLabelHexColor = value =>
  normalizePromotionLabelHexColor(value) || DEFAULT_PROMOTION_LABEL_HEX_COLOR;
